import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { QuoteGeneratorStore } from '../stores/quoteGeneratorStore';

export const useQuoteGeneratorStore = () =>
  useContext<{
    quoteGeneratorStore: QuoteGeneratorStore;
  }>(StoreContext);
